import { axiosInstance } from '@configs/axios/axiosInstance';

import type { InvoiceFilters } from './getInvoiceFilters.types';

export async function getInvoiceFilters(
  organizationId: string
): Promise<InvoiceFilters> {
  const { data } = await axiosInstance.get<InvoiceFilters>('/invoices/filters', {
    headers: { 'X-Organization-Id': organizationId },
  });

  return data;
}
